<template>
  <div class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
    <div class="text-v-ui-gray-900 text-[20px] font-semibold leading-[120%]">
      Дополнительные сведения
    </div>

    <div>
      <VCellGroup
        v-model="componentModel"
        :cells="generateCellGroupAdditionSettings()"
      />

      <VDescription
        type="ghost"
        deviceType="desktop"
        text="При включении настройки КЗС рассчитывается по комбинации индикаторов САД и ДАД. Для генерации задачи достаточно привязки к одному из индикаторов."
      />
    </div>
  </div>
</template>

<script>
import { VCellGroup, VDescription } from '@gostelemed.front/rt-doctis.designsystem';

export default {
  model: {
    prop: 'isPressureKzsModel',
    event: 'input',
  },
  name: 'AdditionalSettingsPart',
  components: {
    VCellGroup,
    VDescription,
  },
  props: {
    isPressureKzsModel: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    componentModel: {
      get() {
        return this.isPressureKzsModel;
      },
      set(value) {
        this.$emit('input', value);
      },
    }
  },
  methods: {
    generateCellGroupAdditionSettings() {
      return [
        {
          // variant: 'gray',
          title: 'Участвует в нозологии артериального давления',
          deviceType: 'desktop',
          wrapSubtitle: true,
          type: 'switch',
          disabled: this.disabled,
          class: '!pl-0 !pt-[8px] !pb-[8px] inline-flex',
          currentValue: { id: 'kzs-is-pressure-kzs-mode' }
        }
      ];
    },
  }
}
</script>
